const defaultUrl = 'https://younoodle.com';
// const functionsUrl = 'http://localhost:5001';
const accountsAppUrl = 'https://accounts.younoodle.com';
const applyAppUrl = 'https://apply.younoodle.com';
const staffAppUrl = 'https://staff.younoodle.com';
const apiAppUrl = 'https://api.younoodle.com';
const apiV1Endpoint = 'https://api.younoodle.com/v1';
const platformUrl = 'https://platform.younoodle.com';
const younoodleDomain = '.younoodle.com';

export const environment =  {
  defaultUrl,
  accountsAppUrl,
  accountsGoogleAnalyticsId: 'UA-1551909-19',
  apiV1Endpoint,
  defaultRedirectUrl: 'https://platform.younoodle.com/dashboard',
  environment: 'production',
  firebase: {
    apiKey: 'AIzaSyCOEPJovo6fNEMlnywmSqBOrncRjnuoQq4',
    authDomain: 'yn-noodles-production.firebaseapp.com',
    projectId: 'yn-noodles-production'
  },
  platformUrl,
  production: true,
  recaptchaSiteKey: '6LdvPdwUAAAAAIgB8aCY5209SQiVQLiCu6GpHqvS',
  recaptchaSecretKey: '6LdvPdwUAAAAADAU0_uWEvzXh_iVEHuuAlKV7yjc',
  // we use this redirectUrlWhitelist for CORS whitelist also
  redirectUrlWhitelist: [
    accountsAppUrl,
    apiAppUrl,
    applyAppUrl,
    defaultUrl,
    younoodleDomain,
    staffAppUrl,
    platformUrl,
    'https://api.ipify.org/'
  ],
  staffAppUrl,
  vpnGuardWhitelist: [
    '73.92.145.131', // Ray's Parents IP
    '76.14.117.239', // Ray's Home IP
    '73.162.136.67', // Ray's Home
    '52.54.107.11', // YN VPN



    '35.185.178.3', // Cobalt's start range ip
    '35.198.53.81',
    '104.196.235.48',
    '104.198.99.165',
    '104.199.49.161',
    '104.199.55.175' // Cobalt's end range ip
  ],
  younoodleDomain
};
